import React, { useCallback, useState } from "react";
import { Handle, Position, useReactFlow } from "reactflow";
import { CloseIcon, EmailNodeIcon } from "../iconSet/IconSet";
import { sourceCustomStyles, targetCustomStyles } from "../workflowCanvas/CustomStyles";
import { EmailNodePropsType } from "./FlowchartTypes";

const EmailNode: React.FC<EmailNodePropsType> = ({ id, data }) => {
    
    const { deleteElements } = useReactFlow();
    const [isHovering, setIsHovering] = useState(false);

    const handleMouseOver = () => {
        setIsHovering(true);
    };

    const handleMouseOut = () => {
        setIsHovering(false);
    };

    const deleteNode = useCallback(() => {
        console.log(id);
        deleteElements({ nodes: [{ id }] });
    }, [id, deleteElements]);

    return (
        <div className={`email-node`} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
            <EmailNodeIcon width='1.7rem'/>
            <span className={`name`}>{data.data.emailtype} - (Dissemination)</span>
            {isHovering && (
                <div className={`node-close-ico`} onClick={deleteNode}>
                    <CloseIcon width='1rem' color="var(--color-main-red)"/>
                </div>
            )}  
            <Handle id="email-target-a" type="target" position={Position.Top} style={{...targetCustomStyles, background: "blue"}}/>
            {/* <Handle id="email-source-a" type="source" position={Position.Bottom} style={{...sourceCustomStyles, background: "yellow"}}/> */}
        </div>
    );
};

export default EmailNode;
